import {
  LoginUrl,
  GetMeUrl,
  SetNewPasswordUrl,
  SendOTPByPhoneUrl,
  LoginOtpUrl,
  LogoutUrl,
  getSecondaryPermissionsUrl,
} from '../api';
import { axios } from '../../../utils/settings';

export const LoginAction = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(LoginUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        console.log('error', error);

        // return next(x)
      });
  });
};
export const logoutAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(LogoutUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  });
};
export const LoginOtpAction = async (phone_number, otp) => {
  return new Promise(async (next) => {
    await axios
      .post(`${LoginOtpUrl()}?phone_number=${phone_number}&otp=${otp}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        console.log('error', error);
        // return next(x)
      });
  });
};
export const SetNewPassword = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(SetNewPasswordUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        return next(error);
      });
  });
};
export const SendOTPByPhoneNow = async (phone_number) => {
  return new Promise(async (next) => {
    await axios
      .get(`${SendOTPByPhoneUrl()}?phone_number=${phone_number}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const GetMeAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(GetMeUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  });
};

export const getSecondaryPermissionsAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(getSecondaryPermissionsUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        console.log(err);
        return next({ error: err });
      });
  });
};

export const getToken = async () => {
  return new Promise(async (next, error) => {
    try {
      // console.log("token is", await AsyncStorage.getItem('token'))
      next(await localStorage.getItem('token'));
    } catch (e) {
      next(null);
    }
  });
};
export const getTokenHeader = (token) => {
  if (!token) return {};
  return {
    headers: { Authorization: 'Bearer ' + token },
  };
};
export const getTokenHeaderFile = (token) => {
  return {
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
      'content-type': 'multipart/form-data;',
    },
  };
};
export const setPWAAction = (is_PWA) => (dispatch) => {
  dispatch({
    type: 'SET_IS_PWA',
    is_PWA,
  });
};
